import _StoreService from './StoreService';

// eslint-disable-next-line import/prefer-default-export
export const StoreService = _StoreService;
